import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getNewAddedItemsTotal } from 'entities/CatalogItem/model/selectors/catalogItemSelectors';

interface ReviewOrderFooterProps {
    children: ReactNode;
}

export const ReviewOrderFooter = ({ children }: ReviewOrderFooterProps) => {
    const { t } = useTranslation();
    const totalSelected = useSelector(getNewAddedItemsTotal);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'row',
                borderRadius: '0 0 12px 12px',
                border: '1px solid',
                borderColor: 'divider',
                p: '16px',
                backgroundColor: 'background.paper',
            }}
            data-testid="add-review-order-footer"
        >
            <Typography variant="body2" sx={{ color: 'common.black' }}>
                {totalSelected > 0
                    ? t('{{count}} item selected', { count: totalSelected })
                    : t('No items selected')}
            </Typography>
            {children}
        </Box>
    );
};
